import axios from 'axios'

const init = {
  headers: {
    'Content-Type': 'application/json',
    'Authorization': 'Basic ' + process.env.AUTH_KEY
  },
  timeout: 3000
}

const api = {
  call: function (opts = {}) {
    let options = {
      method: opts.method || 'get',
      baseURL: opts.baseURL || '',
      url: opts.url || 'admin/v1/',
      params: opts.params || null,
      data: opts.data || null,
      timeout: opts.timeout || init.timeout,
      maxContentLength: 10000,
      headers: Object.assign({
        access_token: opts.access_token
      }, init.headers, opts.headers)
    }
    return axios(options)
  }
}

export default api



// WEBPACK FOOTER //
// ./client/api/index.js